import React from 'react';
import './Contact.css';

function Contact() {
  return (
    <section className="page-section contact-page">
      <div className="section-header">
        <p className="section-eyebrow">Get In Touch</p>
        <h2 className="section-title">Contact</h2>
        <div className="gold-rule" />
      </div>

      <div className="contact-layout">
        <div className="contact-photo">
          {/* Replace this div with an <img> tag pointing to your photo */}
          <div className="contact-photo-placeholder">M</div>
        </div>

        <div className="contact-info">
          <div className="contact-name">
            <span>Book Mike for your event</span>
            Mike Mallick
          </div>

          <div className="contact-details">
            <div className="contact-row">
              <div className="contact-icon">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/>
                  <polyline points="22,6 12,13 2,6"/>
                </svg>
              </div>
              <a href="mailto:mcmallick@gmail.com">mcmallick@gmail.com</a>
            </div>

            <div className="contact-row">
              <div className="contact-icon">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07A19.5 19.5 0 013.07 9.81a19.79 19.79 0 01-3.07-8.63A2 2 0 012.18 0h3a2 2 0 012 1.72 12.84 12.84 0 00.7 2.81 2 2 0 01-.45 2.11L6.91 7.09a16 16 0 006 6l.55-.55a2 2 0 012.11-.45 12.84 12.84 0 002.81.7A2 2 0 0122 14.92z"/>
                </svg>
              </div>
              <span>(240) 460-9016</span>
            </div>
          </div>

          <a className="contact-cta" href="mailto:mcmallick@gmail.com">
            Send a Message
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <line x1="5" y1="12" x2="19" y2="12"/>
              <polyline points="12 5 19 12 12 19"/>
            </svg>
          </a>
        </div>
      </div>
    </section>
  );
}

export default Contact;
